import React, { useRef, useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getCursoData } from "./services/cursoNoCompradoServices";
import SubCategoria from "../../../../components/UniversalTarjetaCurso/components/SubCategoria";
import SubTemarioTarjeta from "./components/SubTemarioTarjeta";
import UniversalIconPerfil from "../../../../components/UniversalIconoPerfil/UniversalIconPerfil";
import { WindowSizeContext } from "../../../../context/WindowSizeContext";

export default function CursoNoComprado({ scrollRef }) {
  const { width } = useContext(WindowSizeContext);
  const [vCursoData, setVCursoData] = useState([]);
  const [searchParams] = useSearchParams();

  const [vIsScrollTop, setVIsScrollTop] = useState(true);

  const mGetCursoDataByIdFetch = () => {
    getCursoData(searchParams.get("curso_id"))
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          switch (result["detail"]["acción"]) {
            case "MOSTRAR_CURSO":
              setVCursoData(result["detail"]["datos"]);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      });
  };
  const mRenderCategoria = () => {
    if (vCursoData.categorias?.length > 0) {
      return vCursoData.categorias.map((vCategoria, vIndex) => (
        <SubCategoria key={vCategoria.id} vCategoria={vCategoria} />
      ));
    }
    return <></>;
  };

  useEffect(() => {
    mGetCursoDataByIdFetch();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      scrollRef.current && scrollRef.current.scrollTop > 0
        ? setVIsScrollTop(false)
        : setVIsScrollTop(true);
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  /** Boton - Ver mas - Requisitos */
  const [mostrarTodosRequisitos, setMostrarTodosRequisitos] = useState(false);
  const [mostrarBotonVerMas, setMostrarBotonVerMas] = useState(false);

  const requisitosRef = useRef(null);

  useEffect(() => {
    const requisitosArray = vCursoData.requisitos
      ? JSON.parse(vCursoData.requisitos)
      : [];
    setMostrarBotonVerMas(requisitosArray.length > 2);
  }, [vCursoData.requisitos]);

  /** Final Requisitoa */

  /** Boton - Ver mas - AcercaDe */

  const [mostrarTodoTexto, setMostrarTodoTexto] = useState(false);
  const [mostrarBotonTexto, setMostrarBotonTexto] = useState(false);
  const acercaDeRef = useRef(null);

  useEffect(() => {
    const evaluarMostrarBoton = () => {
      if (acercaDeRef.current) {
        const lineHeight = parseFloat(
          getComputedStyle(acercaDeRef.current).lineHeight
        );
        const totalLines = Math.round(
          acercaDeRef.current.scrollHeight / lineHeight
        );
        setMostrarBotonTexto(totalLines > 4);
      }
    };

    // Evaluar al montar el componente o cuando cambia el texto
    evaluarMostrarBoton();

    // Agregar listener de resize
    window.addEventListener("resize", evaluarMostrarBoton);

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener("resize", evaluarMostrarBoton);
    };
  }, [vCursoData.acerca_de]);

  /** Final AcercaDe */

  return (
    <>
      <div
        data-figma-id="810:15668"
        class="header-style"
        style={{
          backgroundColor: vIsScrollTop ? "transparent" : "#1d1d1d",
        }}
      >
        <p data-figma-id="810:15669" class="header-texto truncate-1-line">
          Curso {vCursoData.nombre}
        </p>
        <div data-figma-id="810:15670" class="header-iconos">
          <i class="fi fi-rs-bell bell-1-2"></i>
          <UniversalIconPerfil />
        </div>
      </div>
      <div data-figma-id="266:10513" class="curso-no-comprado-contenido-3">
        <div
          data-figma-id="4635:17185"
          class="skill-curso-info-principal-a-cnc"
        >
          <div data-figma-id="4635:17308" class="curso-info-principal-cnc">
            <div data-figma-id="4635:17309" class="curso-info-principal-1">
              <div
                data-figma-id="4635:17310"
                class="curso-info-principal-titulo-2"
              >
                <p
                  data-figma-id="4635:17311"
                  class="curso-info-principal-titulo-texto-2 truncate-3-line"
                >
                  {vCursoData.nombre}
                </p>
              </div>
              <div data-figma-id="4635:17312" class="area-proveedor-2">
                <div data-figma-id="4635:17319" class="curso-precio-2">
                  <p data-figma-id="4635:17320" class="curso-precio-numero-2">
                    ${vCursoData.precio}
                  </p>
                </div>
                <div data-figma-id="4635:17314" class="proveedor-2">
                  <p data-figma-id="4635:17315" class="proveedor-texto-2">
                    MHM GROUP
                  </p>
                </div>
              </div>
              <div
                data-figma-id="4635:17316"
                class="curso-info-principal-contenido-2"
              >
                <p
                  data-figma-id="4635:17317"
                  class="curso-info-principal-contenido-texto-2 truncate-6-line"
                >
                  {vCursoData.objetivo_general}
                </p>
              </div>
              <div data-figma-id="4635:17318" class="curso-precio-prioridad-2">
                <div class="areas-box-curso">{mRenderCategoria()}</div>

                <div
                  onClick={() => window.open(vCursoData.conoce_mas, "_blank")}
                  class="boton-conoce-mas-tablet"
                >
                  <div class="boton-conoce-mas-texto">Conoce más</div>
                </div>
              </div>
            </div>
            <div data-figma-id="4635:17321" class="frame-290008">
              <div data-figma-id="4635:17322" class="curso-info-principal-2">
                <p
                  data-figma-id="4635:17323"
                  class="curso-info-principal-2-texto-2"
                >
                  Este curso incluye:
                </p>
                <div
                  data-figma-id="4635:17324"
                  class="curso-info-principal-2-contenido"
                >
                  <div
                    data-figma-id="4635:17325"
                    class="curso-info-principal-2-contenido-1-2"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe91a72e4a8c038feef1_degree-credential-peque.svg"
                      data-figma-id="4635:17348"
                      class="img-37"
                    />
                    <p
                      data-figma-id="4635:17327"
                      class="curso-info-principal-2-contenido-1-texto"
                    >
                      Un certificado de finalización
                    </p>
                  </div>
                  <div
                    data-figma-id="4635:17328"
                    class="linea-divisora-curso"
                  ></div>
                  <div
                    data-figma-id="4635:17329"
                    class="curso-info-principal-2-contenido-2-2"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe92009b0dcee97ff01b_puzzle-piece--peque.svg"
                      data-figma-id="4635:17350"
                      class="img-38"
                    />
                    <p
                      data-figma-id="4635:17331"
                      class="curso-info-principal-2-contenido-1-texto"
                    >
                      Temario para aprender y aplicar lo estudiado
                    </p>
                  </div>
                  <div
                    data-figma-id="4635:17332"
                    class="linea-divisora-curso"
                  ></div>
                  <div
                    data-figma-id="4635:17333"
                    class="curso-info-principal-2-contenido-3-2"
                  >
                    <div
                      data-figma-id="4635:17352"
                      class="cuestionario-icono-peque-2"
                    >
                      <img
                        src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe937f0a1cf5e671d600_Vector.svg"
                        data-figma-id="4635:17353"
                        class="img-42"
                      />
                    </div>
                    <p
                      data-figma-id="4635:17335"
                      class="curso-info-principal-2-contenido-1-texto"
                    >
                      Cuestionarios para poner a prueba tus conocimientos
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => window.open(vCursoData.conoce_mas, "_blank")}
                class="boton-conoce-mas"
              >
                <div class="boton-conoce-mas-texto">Conoce más</div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-figma-id="4635:17186"
          class="skill-curso-info-principal-contenido-a-cnc"
        >
          <div data-figma-id="4635:17312" class="curso-area-proveedor">
            <div data-figma-id="4635:17314" class="proveedor-2">
              <p data-figma-id="4635:17315" class="proveedor-texto-2">
                MHM Group
              </p>
            </div>
            <div class="areas-box-curso-moivil">{mRenderCategoria()}</div>
            <div data-figma-id="4635:17354" class="boton-favorito-grande-movil">
              <img
                src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe94f2d8ab9eb598d7cb_Vector.svg"
                data-figma-id="4635:17358"
                class="img-22"
              />
            </div>
          </div>
          <div data-figma-id="4635:17318" class="curso-precio-prioridad-movil">
            <div data-figma-id="4635:17319" class="curso-precio-3">
              <p data-figma-id="4635:17320" class="curso-precio-numero-3">
                ${vCursoData.precio}
              </p>
            </div>
            <div data-figma-id="4635:17337" class="prioridad-2-tablet">
              <img
                src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe93f5b2b1e54c19c359_prioridad-grande.svg"
                data-figma-id="4635:17359"
                class="img-23"
              />
              <div class="seleccion-prioridad-curso">
                <p data-figma-id="4635:17339" class="prioridad-texto">
                  Alta
                </p>
                <p data-figma-id="4635:17339" class="prioridad-texto">
                  Media
                </p>
                <p data-figma-id="4635:17339" class="prioridad-texto">
                  Baja
                </p>
              </div>
            </div>

            <div
              onClick={() => window.open(vCursoData.conoce_mas, "_blank")}
              class="boton-conoce-mas-movil"
            >
              <div class="boton-conoce-mas-texto">Conoce más</div>
            </div>
          </div>
          <div data-figma-id="4635:17322" class="curso-info-principal-movil">
            <p
              data-figma-id="4635:17323"
              class="curso-info-principal-2-texto-2"
            >
              Este curso incluye:
            </p>
            <div
              data-figma-id="4635:17324"
              class="curso-info-principal-2-contenido"
            >
              <div
                data-figma-id="4635:17325"
                class="curso-info-principal-2-contenido-1-2"
              >
                <img
                  src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe91a72e4a8c038feef1_degree-credential-peque.svg"
                  data-figma-id="4635:17348"
                  class="img-37"
                />
                <p
                  data-figma-id="4635:17327"
                  class="curso-info-principal-2-contenido-1-texto"
                >
                  Un certificado de finalización
                </p>
              </div>
              <div
                data-figma-id="4635:17328"
                class="linea-divisora-curso"
              ></div>
              <div
                data-figma-id="4635:17329"
                class="curso-info-principal-2-contenido-2-2"
              >
                <img
                  src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe92009b0dcee97ff01b_puzzle-piece--peque.svg"
                  data-figma-id="4635:17350"
                  class="img-38"
                />
                <p
                  data-figma-id="4635:17331"
                  class="curso-info-principal-2-contenido-1-texto"
                >
                  Temario para aprender y aplicar lo estudiado
                </p>
              </div>
              <div
                data-figma-id="4635:17332"
                class="linea-divisora-curso"
              ></div>
              <div
                data-figma-id="4635:17333"
                class="curso-info-principal-2-contenido-3-2"
              >
                <div
                  data-figma-id="4635:17352"
                  class="cuestionario-icono-peque-2"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6728fe937f0a1cf5e671d600_Vector.svg"
                    data-figma-id="4635:17353"
                    class="img-42"
                  />
                </div>
                <p
                  data-figma-id="4635:17335"
                  class="curso-info-principal-2-contenido-1-texto"
                >
                  Cuestionarios para poner a prueba tus conocimientos
                </p>
              </div>
            </div>
          </div>
          <div data-figma-id="4635:17363" class="informativo-curso-cnc">
            <div data-figma-id="4635:17364" class="informativo-curso-1-2">
              <img
                src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6729009aec1b4e35ade006e2_nivel-aprendizaje-icono.svg"
                data-figma-id="4378:18820"
                class="img-18"
              />
              <div
                data-figma-id="4635:17366"
                class="informativo-curso-1-info-2"
              >
                <p
                  data-figma-id="4635:17367"
                  class="informativo-curso-1-texto-1-2"
                >
                  Nivel de aprendizaje
                </p>
                <p
                  data-figma-id="4635:17368"
                  class="informativo-curso-1-texto-2-2"
                >
                  Introductorio
                </p>
              </div>
            </div>
            <div data-figma-id="4635:17369" class="informativo-curso-1-2">
              <img
                src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/672900a3dc12a5ab2d160319_duracion-icono.svg"
                data-figma-id="4581:18065"
                class="img-19"
              />
              <div
                data-figma-id="4635:17371"
                class="informativo-curso-1-info-2"
              >
                <p
                  data-figma-id="4635:17372"
                  class="informativo-curso-1-texto-1-2"
                >
                  Tiempo de duración
                </p>
                <p
                  data-figma-id="4635:17373"
                  class="informativo-curso-1-texto-2-2"
                >
                  {vCursoData.duracion / 3600
                    ? (vCursoData.duracion / 3600).toFixed(1)
                    : Math.floor(vCursoData.duracion / 3600)}{" "}
                  Horas
                </p>
              </div>
            </div>
            <div data-figma-id="4635:17374" class="informativo-curso-1-2">
              <div data-figma-id="4581:18090" class="eleccion-de-idioma-2">
                <img
                  src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/672913355ad0221835191bf5_Group.svg"
                  data-figma-id="4581:18085"
                  class="img-26"
                />
              </div>
              <div
                data-figma-id="4635:17376"
                class="informativo-curso-1-info-2"
              >
                <p
                  data-figma-id="4635:17377"
                  class="informativo-curso-1-texto-1-2"
                >
                  Idioma
                </p>
                <p
                  data-figma-id="4635:17378"
                  class="informativo-curso-1-texto-2-2"
                >
                  Español
                </p>
              </div>
            </div>
            <div data-figma-id="4635:17379" class="informativo-curso-1-2">
              <img
                src="https://cdn.prod.website-files.com/66b63e9bd0a52430ba56b807/6729133c9bcb881fd2e8e706_modalidad-icono.svg"
                data-figma-id="4581:18128"
                class="img-20"
              />
              <div
                data-figma-id="4635:17381"
                class="informativo-curso-1-info-2"
              >
                <p
                  data-figma-id="4635:17382"
                  class="informativo-curso-1-texto-1-2"
                >
                  Modalidad
                </p>
                <p
                  data-figma-id="4635:17383"
                  class="informativo-curso-1-texto-2-2"
                >
                  En línea
                </p>
              </div>
            </div>
          </div>
          <div data-figma-id="4635:17189" class="info-extra-curso-cnc">
            <div data-figma-id="4378:20032" class="requerimientos-curso-cnc">
              <p
                data-figma-id="4378:20030"
                class="requerimientos-curso-texto-1-2"
              >
                Requerimientos
              </p>

              <div className="apartado-curso-info-texto-box">
                <ul
                  ref={requisitosRef}
                  style={{
                    listStyleType: "disc",
                    paddingLeft: "1.5rem",
                    color: "white",
                    width: "100%",
                  }}
                >
                  {(vCursoData.requisitos
                    ? JSON.parse(vCursoData.requisitos)
                    : []
                  )
                    .slice(0, mostrarTodosRequisitos ? undefined : 2)
                    .map((item, index) => (
                      <li
                        key={index}
                        style={{
                          marginBottom: "0.3rem",
                          lineHeight: "0.5",
                        }}
                      >
                        <p
                          className="requerimientos-curso-texto-2-2"
                          style={{ color: "white", lineHeight: "1.75" }}
                        >
                          {item}
                        </p>
                      </li>
                    ))}
                </ul>

                {mostrarBotonVerMas && (
                  <div
                    onClick={() => setMostrarTodosRequisitos((prev) => !prev)}
                    class="boton-ver-mas-texto-2"
                  >
                    {mostrarTodosRequisitos ? "Ver menos" : "Ver más"}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            data-figma-id="4635:17189"
            class="info-extra-curso-2-acerca-de-cnc"
          >
            <div data-figma-id="4378:20032" class="requerimientos-curso-cnc">
              <p
                data-figma-id="4378:20030"
                class="requerimientos-curso-texto-1-2"
              >
                Acerca de
              </p>
              <div class="apartado-curso-info-texto-box">
                <p
                  ref={acercaDeRef}
                  className={`requerimientos-curso-texto-2-2 ${
                    !mostrarTodoTexto ? "truncate-4-line" : ""
                  }`}
                >
                  {vCursoData.acerca_de}
                </p>
                {mostrarBotonTexto && (
                  <div
                    onClick={() => setMostrarTodoTexto((prev) => !prev)}
                    class="boton-ver-mas-texto-2"
                  >
                    {mostrarTodoTexto ? "Ver menos" : "Ver más"}
                  </div>
                )}
              </div>
            </div>
          </div>

          {console.log(vCursoData)}
          <SubTemarioTarjeta vArrSecciones={vCursoData.secciones} />
        </div>
      </div>
    </>
  );
}
